/* tslint:disable */
import {
  Product,
  ProductUom,
  StockLocation
} from '../index';

declare var Object: any;
export interface StockPickingLineInterface {
  "id"?: number;
  "quantity": number;
  "product_id"?: number;
  "product_uom"?: number;
  "location_id"?: number;
  "location_dest_id"?: number;
  product?: Product;
  uom?: ProductUom;
  location?: StockLocation;
  location_dest?: StockLocation;
}

export class StockPickingLine implements StockPickingLineInterface {
  "id": number;
  "quantity": number;
  "product_id": number;
  "product_uom": number;
  "location_id": number;
  "location_dest_id": number;
  product: Product;
  uom: ProductUom;
  location: StockLocation;
  location_dest: StockLocation;
  constructor(data?: StockPickingLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockPickingLine`.
   */
  public static getModelName() {
    return "StockPickingLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockPickingLine for dynamic purposes.
  **/
  public static factory(data: StockPickingLineInterface): StockPickingLine{
    return new StockPickingLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockPickingLine',
      plural: 'StockPickingLines',
      path: 'StockPickingLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "quantity": {
          name: 'quantity',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "product_uom": {
          name: 'product_uom',
          type: 'number'
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "location_dest_id": {
          name: 'location_dest_id',
          type: 'number'
        },
      },
      relations: {
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        uom: {
          name: 'uom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom',
          keyTo: 'id'
        },
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        location_dest: {
          name: 'location_dest',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_dest_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockPickingLine.ts